<nav class="profile-nav">
  <a *ngFor="let item of items; let index = index" class="d-flex align-items-center"
     routerLink="/profile/{{item.path}}"
     routerLinkActive="font-weight-bold">
    <span [inlineSVG]="'assets/img/' + item.icon + '.svg'"
          class="svg-18 d-flex justify-content-center align-items-center" *ngIf="item.description !== 'sms-language'"></span>
    <span class="svg-18 d-flex justify-content-center align-items-center" *ngIf="item.description === 'sms-language'">
      <img class="lang-img"
           style="width: 20px"
           src="assets/img/languageIcons/{{preferredLanguage}}.png"
           alt="">
    </span>
    {{item.description | translate}}
  </a>
  <a (click)="helpCrunchService.showHelpCrunch()"
     class="d-flex align-items-center cursor-pointer"
     routerLinkActive="font-weight-bold">
    <span [inlineSVG]="'assets/img/comment.svg'" class="svg-18 d-flex justify-content-center align-items-center"></span>
    {{'help'|translate}}
  </a>
</nav>
